import {
  apiRequestGet,
  apiRequestPost,
  apiRequestPut,
  apiRequestDelete,
} from 'mastodon/api';

import type {
  ApiChatRoomJSON,
  ApiChatMessageJSON,
  ApiCreateChatPayload,
  ApiSendChatMessagePayload,
  ApiChatEncryptionPayload,
} from '../api_types/chat';

export const apiGetChatRooms = (params?: { max_id?: string }) =>
  apiRequestGet<ApiChatRoomJSON[]>('v1/chats', params);

export const apiGetChatRoom = (id: string) =>
  apiRequestGet<ApiChatRoomJSON>(`v1/chats/${id}`);

export const apiCreateChatRoom = (payload: ApiCreateChatPayload) =>
  apiRequestPost<ApiChatRoomJSON>('v1/chats', payload);

export const apiRenameChatRoom = (id: string, name: string) =>
  apiRequestPut<ApiChatRoomJSON>(`v1/chats/${id}`, { name });

export const apiLeaveChatRoom = (id: string) =>
  apiRequestDelete(`v1/chats/${id}`);

export const apiMarkChatRead = (id: string, maxId?: string) =>
  apiRequestPost<ApiChatRoomJSON>(`v1/chats/${id}/read`, { max_id: maxId });

export const apiAcceptChatRoom = (id: string) =>
  apiRequestPost<ApiChatRoomJSON>(`v1/chats/${id}/accept`);

export const apiSetChatRoomEncryption = (
  id: string,
  payload: ApiChatEncryptionPayload,
) => apiRequestPut<ApiChatRoomJSON>(`v1/chats/${id}/encryption`, payload);

// Reports that *this* participant's own client derived a key that decrypts
// the room's stored verifier -- never the key itself. See
// ChatRoom#keys_confirmed?.
export const apiConfirmChatKey = (id: string) =>
  apiRequestPost<ApiChatRoomJSON>(`v1/chats/${id}/key_confirmed`);

export const apiGetChatMessages = (
  roomId: string,
  params?: { max_id?: string },
) => apiRequestGet<ApiChatMessageJSON[]>(`v1/chats/${roomId}/messages`, params);

export const apiSendChatMessage = (
  roomId: string,
  payload: ApiSendChatMessagePayload,
) => apiRequestPost<ApiChatMessageJSON>(`v1/chats/${roomId}/messages`, payload);

export const apiDeleteChatMessage = (roomId: string, id: string) =>
  apiRequestDelete(`v1/chats/${roomId}/messages/${id}`);

export const apiAddChatParticipants = (roomId: string, accountIds: string[]) =>
  apiRequestPost<ApiChatRoomJSON>(`v1/chats/${roomId}/participants`, {
    account_ids: accountIds,
  });

export const apiRemoveChatParticipant = (roomId: string, accountId: string) =>
  apiRequestDelete<ApiChatRoomJSON>(
    `v1/chats/${roomId}/participants/${accountId}`,
  );
